exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "dv-tooltip{font-size:1.6rem}dv-tooltip i:focus{outline:0;color:#687276}dv-tooltip:hover i{color:#bc2500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-tooltip/dv-tooltip.scss
// module id = 6ZDT
// module chunks = 0